import { apiRequest } from "./api";

// Maps the wizard's credit row shape ({ vin, cat, logging, reason, date,
// explanation, amount }) onto the backend's CreditRowRequest shape.
// categoryCd/logging aren't IRS elements (CreditsAmountStatement.xsd has no
// category), but the backend persists them anyway so the Credits page can
// keep showing what the filer picked after navigating away and back.
function toRequestBody(rows) {
  return {
    credits: rows.map((r) => ({
      vin: r.vin,
      reasonCd: r.reason,
      creditDate: r.date,
      creditAmt: Number(r.amount) || 0,
      explanation: r.explanation,
      categoryCd: r.cat || null,
      logging: !!r.logging,
    })),
  };
}

// Maps a CreditRowResponse back onto the wizard's row shape - explanation,
// the saved amount, and now categoryCd/logging are all authoritative server
// values (rows saved before those columns existed come back with cat: "").
function fromResponseRow(r) {
  return {
    id: r.id,
    vin: r.vin,
    cat: r.categoryCd || "",
    logging: !!r.logging,
    reason: r.reasonCd,
    date: r.creditDate,
    explanation: r.explanation || "",
    amount: String(r.creditAmt),
  };
}

// GET /returns/{returnId}/credits -> the return's saved Line-5 credit rows.
export async function getCredits(returnId) {
  const data = await apiRequest(`/returns/${returnId}/credits`);
  return Array.isArray(data?.credits) ? data.credits.map(fromResponseRow) : [];
}

// PUT /returns/{returnId}/credits -> atomically replaces all credit rows;
// recomputes creditsAmt (Line 5) and balanceDueAmt (Line 6) server-side.
export async function saveCredits(returnId, rows) {
  const data = await apiRequest(`/returns/${returnId}/credits`, {
    method: "PUT",
    body: toRequestBody(rows),
  });
  return Array.isArray(data?.credits) ? data.credits.map(fromResponseRow) : [];
}
